import { render } from "./BroadcastSettingsViewMessageCreateModal.vue?vue&type=template&id=72a0d304"
import script from "./BroadcastSettingsViewMessageCreateModal.vue?vue&type=script&lang=js"
export * from "./BroadcastSettingsViewMessageCreateModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__